import { useCallback, useEffect, useState } from 'react'
import MeService from '../services/me-service'
import PaymentService from '../services/payment-service'
import GrileService from '../services/grile-service'
import { toast } from 'react-toastify'

const useProfile = () => {
  const [profileData, setProfileData] = useState({})
  const [profileDataForModal, setProfileDataForModal] = useState({})
  const [paymentData, setPaymentData] = useState({})
  const [allUniversities, setAllUniversities] = useState([])
  const [tab, setTab] = useState(0)
  const [isGeneralModalOpened, setIsGeneralModalOpened] = useState(false)
  const [isChangePasswordModalOpened, setIsChangePasswordModalOpened] =
    useState(false)

  const [error, setError] = useState({
    name: false,
    phone: false,
  })

  const handleChange = useCallback((event, newValue) => {
    setTab(newValue)
  }, [])

  const handleGetData = async () => {
    try {
      const data = await MeService.getProfileData()
      const allUniversities = await GrileService.getAllFaculties()
      setAllUniversities(allUniversities)
      const invoices = await PaymentService.invoices()
      setProfileData({
        name: data.name,
        email: data.email,
        phone:
          data.phone_number === 'null' || !data.phone_number
            ? '-'
            : data.phone_number,
        acc: data.teacher ? 'Profesor' : 'Elev',
        uni: data.faculties.map(facultate => facultate.short_name).join('; '),
        achievements: data.achievements,
        uniList: data.faculties,
        nickname: data.nickname,
        account_type: data.account_type,
      })
      setProfileDataForModal({
        name: data.name,
        email: data.email,
        phone:
          data.phone_number === 'null' || !data.phone_number
            ? '+40'
            : data.phone_number,
        acc: data.teacher ? 'Profesor' : 'Elev',
        uni: data.faculties.map(facultate => facultate.short_name).join('; '),
        achievements: data.achievements,
        uniList: data.faculties,
        nickname: data.nickname,
        account_type: data.account_type,
      })
      setPaymentData({
        cards: data.payment_details,
        payments: invoices,
      })
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    handleGetData()
  }, [])

  const phoneNumberRegex = /^\+\d{2,11}$/

  const handleInput = e => {
    const { name, value } = e.target
    if (name === 'phone' && !phoneNumberRegex.test(value)) {
      return
    }
    if (name === 'name' && value.trim().length === 0) {
      setError(prev => ({ ...prev, name: true }))
    }
    if (name === 'name' && value.trim().length > 0 && error.name) {
      setError(prev => ({ ...prev, name: false }))
    }
    setProfileDataForModal(prevState => ({
      ...prevState,
      [name]: value,
    }))
  }
  const handleUniversitiesChange = universities => {
    setProfileDataForModal(prev => ({
      ...prev,
      uniList: universities,
    }))
  }

  const handleUpdateData = async event => {
    event.preventDefault()
    try {
      await MeService.updateUserProfileData(profileDataForModal)
      const universitiesIds = profileDataForModal.uniList.map(uni => uni.id)
      await MeService.updateUserUniversities({
        faculties_ids: universitiesIds,
      })
    } catch (error) {
      toast.error('Nu am putut salva datele')
      console.error(error)
    } finally {
      setIsGeneralModalOpened(false)
      setProfileData(profileDataForModal)
    }
  }

  const remainedUniversities = allUniversities?.filter(
    uni => {
      return !profileDataForModal?.uniList?.map(uni => uni.id)?.includes(uni.id)
    },
    [allUniversities, profileDataForModal],
  )

  const modalUniversitiesIds =
    profileDataForModal?.uniList?.map(uni => uni.id) || []
  const profileUniversitiesIds = profileData?.uniList?.map(uni => uni.id) || []

  const areTheSameUniversities =
    modalUniversitiesIds.length === profileUniversitiesIds.length &&
    [...modalUniversitiesIds]
      .sort((a, b) => a - b)
      .every(
        (id, index) =>
          id === [...profileUniversitiesIds].sort((a, b) => a - b)[index],
      )

  const isSaveButtonDisabled =
    profileDataForModal?.name?.trim().length === 0 ||
    profileDataForModal?.phone?.trim().length === 0 ||
    (profileDataForModal.name === profileData.name &&
      profileDataForModal.phone === profileData.phone &&
      areTheSameUniversities)

  return {
    profileData,
    paymentData,
    handleUpdateData,
    handleInput,
    tab,
    handleChange,
    remainedUniversities,
    isGeneralModalOpened,
    setIsGeneralModalOpened,
    profileDataForModal,
    isSaveButtonDisabled,
    handleUniversitiesChange,
    isChangePasswordModalOpened,
    setIsChangePasswordModalOpened,
    error,
  }
}

export default useProfile
